module.exports = __webpack_public_path__ + "img/mntn_03.fa4dca44.svg";